// extracted by mini-css-extract-plugin
module.exports = {"tag":"tag_tag__3o7Ju","tagContent":"tag_tagContent__150cZ","tagColor":"tag_tagColor__1eD62"};